// import { Link } from 'react-scroll';
// import { useState, useEffect } from 'react';

// export default function Navbar() {
//   const [navBg, setNavBg] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setNavBg(window.scrollY > 20);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   return (
//     <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${navBg ? 'bg-white shadow' : 'bg-transparent'}`}>
//       <div className="max-w-6xl mx-auto px-4 py-3 flex justify-between items-center">
//         <h1 className="text-xl font-bold text-blue-600">Siva Sai</h1>
//         <ul className="flex space-x-6 text-sm font-medium text-gray-700">
//           <li>
//             <Link to="hero" smooth duration={500} className="cursor-pointer hover:text-blue-500">
//               Home
//             </Link>
//           </li>
//           <li>
//             <Link to="about" smooth duration={500} className="cursor-pointer hover:text-blue-500">
//               About
//             </Link>
//           </li>
//           <li>
//             <Link to="projects" smooth duration={500} className="cursor-pointer hover:text-blue-500">
//               Projects
//             </Link>
//           </li>
//           <li>
//             <Link to="contact" smooth duration={500} className="cursor-pointer hover:text-blue-500">
//               Contact
//             </Link>
//           </li>
//         </ul>
//       </div>
//     </nav>
//   );
// }

import { Link } from 'react-scroll';
import { useState, useEffect } from 'react';
import { Menu, Moon, Sun, X } from 'lucide-react';

export default function Navbar({ theme, onToggleTheme }) {
  const [navBg, setNavBg] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    let ticking = false;

    const updateNavBackground = () => {
      const shouldUseBackground = window.scrollY > 20;
      setNavBg((previous) => (previous === shouldUseBackground ? previous : shouldUseBackground));
      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateNavBackground);
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    updateNavBackground();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    { id: 'intro', label: 'Intro' },
    { id: 'about', label: 'Story' },
    { id: 'projects', label: 'Projects' },
    { id: 'contact', label: 'Contact' },
  ];

  return (
    <nav className="fixed top-0 w-full z-50 px-3 pt-3 md:px-6 md:pt-5">
      <div className={`nav-shell mx-auto flex max-w-6xl items-center justify-between rounded-full border px-4 py-3 transition-all duration-300 md:px-6 ${navBg ? 'border-slate-700/80 bg-slate-950/80 shadow-2xl' : 'border-slate-800/70 bg-slate-950/45'}`}>
        <div>
          <p className="mono text-[11px] uppercase tracking-[0.35em] text-sky-300/80">Portfolio</p>
          <h1 className="text-sm font-semibold text-slate-100 md:text-base">Siva Sai Kumar Kudupudi</h1>
        </div>

        <div className="hidden items-center gap-4 md:flex">
          <ul className="flex items-center gap-6 text-sm font-medium text-slate-300">
            {menuItems.map((item) => (
              <li key={item.id}>
                <Link to={item.id} smooth duration={500} offset={-80} className="cursor-pointer transition hover:text-sky-300">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>

          <button
            type="button"
            onClick={onToggleTheme}
            className="theme-toggle inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium text-slate-200 transition hover:text-sky-300"
            aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
          >
            {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
            <span>{theme === 'dark' ? 'Light' : 'Dark'}</span>
          </button>
        </div>

        <div className="flex items-center gap-3 md:hidden">
          <button
            type="button"
            onClick={onToggleTheme}
            className="theme-toggle inline-flex items-center justify-center rounded-full border p-2 text-slate-100 transition hover:text-sky-300"
            aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
          >
            {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          </button>

          <div className="text-slate-100">
            {mobileOpen ? (
              <X className="w-6 h-6 cursor-pointer" onClick={() => setMobileOpen(false)} />
            ) : (
              <Menu className="w-6 h-6 cursor-pointer" onClick={() => setMobileOpen(true)} />
            )}
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="nav-drawer mx-auto mt-3 max-w-6xl rounded-3xl border border-slate-800/80 bg-slate-950/90 px-6 py-5 shadow-2xl md:hidden">
          <ul className="flex flex-col space-y-3 text-slate-300">
            {menuItems.map((item) => (
              <li key={item.id}>
                <Link
                  to={item.id}
                  smooth
                  duration={500}
                  offset={-80}
                  className="cursor-pointer text-lg transition hover:text-sky-300"
                  onClick={() => setMobileOpen(false)}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
}
